export default function Dash() {
  return (
    <>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2008_95217)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 9.24854H2V7.99854H14V9.24854Z"
            fill="#007383"
          />
        </g>
        <defs>
          <clipPath id="clip0_2008_95217">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0 0.623535)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
